import {ContentContainer} from '@coolcolduk/ui-mui';
import {Box, Tab, Tabs} from '@mui/material';
import {useLocation, useNavigate} from 'react-router';
import PageHeader from '../../components/PageHeader';
import {PrivateRouteProps} from '../../config/routeType';
import GeneralSettingsPage from './general/GeneralSettingsPage';
import ModuleSettingsPage from './module/ModuleSettingsPage';
import PermissionSettingsPage from './permission/PermissionSettingsPage';

const settingsList = [
  {
    label: 'General',
    path: '/settings/general',
    component: GeneralSettingsPage,
  },
  {
    label: 'Module',
    path: '/settings/module',
    component: ModuleSettingsPage,
  },
  {
    label: 'Permission',
    path: '/settings/permission',
    component: PermissionSettingsPage,
  },
];

export default function SettingsPage({user}: PrivateRouteProps) {
  const location = useLocation();
  const navigate = useNavigate();

  const handleTabChange = (_event: React.SyntheticEvent, newValue: string) => {
    navigate(newValue);
  };

  return (
    <ContentContainer data-testid="settings-page">
      <PageHeader title="Settings" />

      <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
        <Tabs
          onChange={handleTabChange}
          aria-label="settings tabs"
          value={location.pathname}
          sx={{
            '& .MuiTab-root': {
              textTransform: 'none',
              fontSize: '1rem',
              fontWeight: 500,
              minHeight: 48,
            },
          }}
        >
          {settingsList.map((tab) => (
            <Tab key={tab.label} label={tab.label} value={tab.path} />
          ))}
        </Tabs>
      </Box>

      <Box sx={{pt: 3}}>
        {settingsList.map((tab) => (
          <Box key={tab.label} sx={{display: location.pathname === tab.path ? 'block' : 'none'}}>
            <tab.component user={user} />
          </Box>
        ))}
      </Box>
    </ContentContainer>
  );
}
